import { LinksFunction, LoaderFunctionArgs, MetaFunction, json } from '@remix-run/node';
import {
  Links,
  LiveReload,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  isRouteErrorResponse,
  useLoaderData,
  useRouteError,
} from '@remix-run/react';
import { cssBundleHref } from '@remix-run/css-bundle';
import { UserInfoContextProvider, LoginDialogContextProvider } from './signalsAndContext/LoginContext';
import { getAuthInfo } from './helpers/auth.server';
import { PromptDialog } from './components/dialogs/PromptDialog';
import { showPromatDialog } from './signalsAndContext/global';

/**
 * 获取需要向客户端注入的环境变量
 * @returns {Record<string, string>}
 */
function getEnv() {
  return {};
}

export const meta: MetaFunction = () => ([
  {
    charset: 'utf-8',
  }
]);


export const links: LinksFunction = () => [
  ...(cssBundleHref
    ? [
      {
        rel: 'stylesheet', href: cssBundleHref,
      },
    ]
    : []),
];

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const userInfo = await getAuthInfo(request);

  return json({ userInfo, env: getEnv() });
};

export default function App() {
  const { env, userInfo } = useLoaderData<typeof loader>();

  return (
    <html suppressHydrationWarning={true}>
      <head>
        <link href="/favicon.ico" rel="shortcut icon" type="image/x-icon" />
        <Meta />
        <Links />
        <script src="https://accounts.google.com/gsi/client"></script>
        <script src="https://www.google.com/recaptcha/api.js?render=explicit"></script>
        {/* 移动到由 remix-utils 中的 ExternalScripts 管理 */}
        {/* <script src="https://www.google.com/recaptcha/api.js?render=explicit"></script> */}
        {/* 依赖 remix-utils 工具中来完成按 page 引入 script lib */}
        {/* {
          isHydrated && <ExternalScripts />
        } */}
      </head>
      <body>
        <UserInfoContextProvider user={userInfo}>
          <LoginDialogContextProvider>
            <Outlet />
          </LoginDialogContextProvider>
        </UserInfoContextProvider>
        {
          showPromatDialog.value && <PromptDialog
            {...showPromatDialog.value}
          />
        }
        <div className="m-toast-box" id="toastBox" />

        <ScrollRestoration getKey={({ state, key }) => {
          // 路由变化的时： 处理页面滚动
          if (state && state.type === 'scroll' && typeof state.top !== 'undefined') {
            // 当页面跳转时： 可以回滚到页面顶部
            if (state.container === 'body') {
              document.body.scrollTo(0, state.top);
            } else {
              document.documentElement.scrollTop = state.top;
            }
          }
          return key;
        }} />
        {/* 向 window 中注入环境变量 */}
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(env)}`,
          }}
        />
        <Scripts />
        <LiveReload />
      </body>
    </html>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    return (
      <div>
        <h1>
          {error.status} {error.statusText}
        </h1>
        <p>{error.data}</p>
      </div>
    );
  } if (error instanceof Error) {
    console.error(error);
    return (
      <div>
        <h1>Error</h1>
        <p>{error.message}</p>
        <p>The stack trace is:</p>
        <pre>{error.stack}</pre>
      </div>
    );
  }
  return <h1>Unknown Error</h1>;
}


